import catalogJson from "./catalog.json";
import { Button } from "antd";
import { iconsAndImages } from "../../assets/images";
import "./style.scss";

export const Catalog = () => {
    return (
        <>
            <section className="py-5">
                <div className="container">
                    <span className="text-yellow fw-bold d-block mb-2">
                        {catalogJson?.info}
                    </span>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-2">
                        <h1 className="bebas-neue-regular mb-0">
                            {catalogJson?.title}
                        </h1>
                        <a href="/products" className="text-decoration-none fw-semibold">
                            View Full Inventory
                        </a>
                    </div>
                    <div className="row g-4">
                        {catalogJson?.listOfCatalog?.map((details, index) => (
                            <div
                                className="col-6 col-lg-3"
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                            >
                                <div className="catalog-card h-100">
                                    <div className="catalog-img-wrap">
                                        <img
                                            src={iconsAndImages[details?.catalogImg]}
                                            alt={details?.name}
                                            className="catalog-img"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="p-3">
                                        <h5 className="fw-bold pb-2">
                                            {details?.name}
                                        </h5>
                                        <p className="fw-normal small">
                                            {details?.description}
                                        </p>
                                        <div className="d-flex justify-content-between">
                                            {/* <Button type="primary" className="fw-bold" style={{ fontSize: "10px" }}>
                                                Request Sample
                                            </Button> */}
                                            <Button className="fw-bold w-100" type="primary" style={{ fontSize: "10px" }}>
                                                Bulk Inquiry
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
